import * as OvationsApi from 'core/ovations-api';
import { EmailScheduleType } from 'core/enums/EmailNotificationScheduler';

export const mockPortalNotificationContent: OvationsApi.Types.PortalNotificationContent = {
    subject: 'Email Subject',
    emailContent: 'Email Body',
    smsContent: 'SMS Body',
    isActive: true,
    oneTimeReminderDays: null,
    recurrenceFrequency: null,
    recurringStopAfterDays: null,
    emailScheduleType: EmailScheduleType.Never,
    stopAfterEnabled: false,
};

export const mockPortalNotificationTokens: OvationsApi.Types.PortalNotificationTokens = {
    registration: {
        additionalProp1: 'string1',
    },
    passwordReset: {
        additionalProp2: 'string2',
    },
    passwordChanged: {
        additionalProp3: 'string3',
    },
    claimSubmission: {
        additionalProp4: 'string4',
    },
    claimIncomplete: {
        additionalProp5: 'string5',
    },
    claimAdditionalIncomplete: {
        additionalProp6: 'string6',
    },
    mailInRegistration: {
        additionalProp7: 'string7',
    },
    claimDisqualification: {
        additionalProp8: 'string8',
    },
    referredIndividualConfirmation: {
        additionalProp9: 'string9',
    },
    claimFulfilled: {
        additionalProp10: 'string10',
    },
    customerUpdated: {
        additionalProp11: 'string11',
    },
    readyToRedeem: {
        additionalProp12: 'string12',
    },
};

export const mockPortalNotification: OvationsApi.Types.PortalNotification = {
    programId: '_porgramId_',
    registration: mockPortalNotificationContent,
    mailInRegistration: mockPortalNotificationContent,
    passwordReset: mockPortalNotificationContent,
    passwordChanged: mockPortalNotificationContent,
    claimSubmission: mockPortalNotificationContent,
    claimIncomplete: mockPortalNotificationContent,
    claimAdditionalIncomplete: mockPortalNotificationContent,
    claimDisqualification: mockPortalNotificationContent,
    referredIndividualConfirmation: mockPortalNotificationContent,
    claimFulfilled: mockPortalNotificationContent,
    customerUpdated: mockPortalNotificationContent,
    readyToRedeem: mockPortalNotificationContent,
};

export default mockPortalNotification;
